import zhCN from './json/enroll-lottery.zh_CN.json';
import zhTW from './json/enroll-lottery.zh_TW.json';
import en from './json/enroll-lottery.en.json';
import ja from './json/enroll-lottery.ja.json';
import ko from './json/enroll-lottery.ko.json';
import ru from './json/enroll-lottery.ru.json';
export default {
  zh_CN: zhCN,
  zh_TW: zhTW,
  en,
  ja,
  ko,
  ru
};
